module.exports = __webpack_public_path__ + "img/4.21842edd.jpg";